export const exist = (el: any) => el;
